import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagBW = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M1.18 17.391A24.977 24.977 0 0 0 0 25c0 2.653.415 5.209 1.18 7.608L25 33.696l23.82-1.088C49.584 30.21 50 27.653 50 25c0-2.654-.415-5.21-1.18-7.609L25 16.304 1.18 17.391Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M50 25.001c0-1.483-.13-2.936-.378-4.348H.378a25.132 25.132 0 0 0 0 8.696h49.244A25.16 25.16 0 0 0 50 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M25 50c11.154 0 20.6-7.305 23.82-17.392H1.18C4.4 42.695 13.847 50 25 50ZM25 0C13.846 0 4.4 7.305 1.18 17.391h47.64C45.6 7.305 36.153 0 25 .001Z"
}));
FlagBW.displayName = 'FlagBW';
export default withFlagWrapper(FlagBW);
//# sourceMappingURL=index.js.map